import { REGROUPEMENT } from '@/configuration/devisConf';
import { CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';

export default function getMessageAvertissement(devisWithNewData) {
  const allMessage = [];
  devisWithNewData.messagesAvertissement.forEach((message) => {
    const splitMessage = message.errorMessage.split('|')[0].split('@');
    allMessage.push({
      key: splitMessage[0],
      produit: splitMessage[1],
      libelle: splitMessage[2],
      anneeSemaine: splitMessage[3],
    });
  });

  devisWithNewData.lignesCommande
    .filter((ligne) => {
      return ligne.type === REGROUPEMENT && ligne.typeProduit === CATEGORIE_REGROUPEMENT;
    })
    .forEach((ligne) => {
      const ligneHaveMessage = allMessage.find((message) => {
        return ligne.produitId === message.produit
          && ligne.ligneReseau.anneeSemaine.toString() === message.anneeSemaine
          && ligne.libelle === message.libelle;
      });
      if (ligneHaveMessage) {
        ligne.messagesAvertissement = 'optionBlocage.messageErreurQuantite';
      }
    });
}
